module.exports = dibs_buyer_layout;


//////////////////
// WEBPACK FOOTER
// external "dibs_buyer_layout"
// module id = 22
// module chunks = 63